import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import AdminLayout from '../../components/admin/AdminLayout'

export default function AdminBuilderProjects() {
    const [search, setSearch] = useState('')

    const properties = [
        {
            _id: 'PBKS9',
            buildingName: 'Pratham Parisar',
            propertyCategory: 'Residential',
            subCategory: 'Apartment',
            propertyType: 'Residential',
            area: 'Gota',
            city: 'Ahmedabad',
            bhkConfiguration: '1 BHK',
            furnishingType: 'N/A',
            priceMin: '300000',
            priceMax: '350000',
            size: 800,
            status: 'Available',
            description: 'Best in 1 bhk for investors',
            createdAt: '2026-04-19T10:30:00Z'
        },
        {
            _id: 'PBX12',
            buildingName: 'Aster Heights',
            propertyCategory: 'Commercial',
            subCategory: 'Showroom',
            propertyType: 'Commercial',
            area: 'Sindhu Bhavan',
            city: 'Ahmedabad',
            bhkConfiguration: 'N/A',
            furnishingType: 'Unfurnished',
            priceMin: '1200000',
            priceMax: '2500000',
            size: 2400,
            status: 'Available',
            description: 'Ultra-luxurious premium business location',
            createdAt: '2026-04-20T11:45:00Z'
        }
    ];

    const filtered = properties.filter(p => 
        p.buildingName.toLowerCase().includes(search.toLowerCase()) ||
        p.city.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <AdminLayout>
            {/* Top Bar Filters matching screenshot */}
            <div className="flex flex-wrap items-center justify-between gap-4 mb-3 select-none bg-white p-3 rounded-2xl border border-slate-100 shadow-sm max-w-fit md:max-w-none">
                <div className="flex flex-wrap items-center gap-3">
                    {/* Date select */}
                    <input type="text" placeholder="Select date" className="px-4 py-2 border border-slate-200 rounded-xl text-xs font-medium text-slate-600 outline-none focus:ring-2 focus:ring-[#5B32B4]" />

                    {/* Range select */}
                    <select className="px-4 py-2 border border-slate-200 rounded-xl text-xs font-bold text-slate-600 outline-none focus:ring-2 focus:ring-[#5B32B4] cursor-pointer">
                        <option>Range</option>
                    </select>

                    {/* All select */}
                    <select className="px-4 py-2 border border-slate-200 rounded-xl text-xs font-bold text-slate-600 outline-none focus:ring-2 focus:ring-[#5B32B4] cursor-pointer">
                        <option>All</option>
                    </select>

                    {/* Search premise name */}
                    <div className="relative flex items-center bg-white border border-slate-200 rounded-xl px-2 focus-within:ring-2 focus-within:ring-[#5B32B4] transition-all">
                        <input 
                            type="text" 
                            className="w-[200px] md:w-[250px] py-2 px-2 text-xs font-medium text-slate-700 outline-none bg-transparent placeholder:text-slate-400"
                            placeholder="Enter premise names" 
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                        <button className="w-8 h-8 flex items-center justify-center bg-[#5B32B4] hover:bg-slate-800 text-white rounded-xl transition-all shadow-sm">
                            <i className="fa-solid fa-magnifying-glass text-xs"></i>
                        </button>
                    </div>

                    {/* All Filter Button */}
                    <button className="flex items-center gap-2 px-4 py-2 bg-[#5B32B4] hover:bg-slate-800 text-white font-bold text-xs rounded-xl transition-all shadow-sm">
                        <i className="fa-solid fa-sliders text-xs"></i> All Filter
                    </button>
                </div>

                {/* Change view controls */}
                <div className="flex items-center gap-2">
                    <button className="w-8 h-8 flex items-center justify-center bg-[#5B32B4] text-white rounded-xl shadow-sm">
                        <i className="fa-solid fa-table-cells-large text-xs"></i>
                    </button>
                    <button className="w-8 h-8 flex items-center justify-center bg-white text-slate-400 hover:text-slate-600 rounded-xl border border-slate-200">
                        <i className="fa-solid fa-list text-xs"></i>
                    </button>
                    <Link to="/admin-add-property" className="px-5 py-2.5 bg-[#5B32B4] hover:bg-slate-800 text-white rounded-xl text-xs font-bold transition-all flex items-center justify-center gap-2 shadow-sm whitespace-nowrap">
                        <i className="fa-solid fa-plus text-xs"></i> Add Property
                    </Link>
                </div>
            </div>

            {/* Sub-header text matching exact highlight */}
            <div className="mb-6 select-none max-w-fit">
                <span className="bg-indigo-600 text-white font-bold text-xs px-3.5 py-1 rounded-md shadow-sm">
                    {filtered.length} Properties found
                </span>
            </div>

            {/* Builder project card list */}
            <div className="space-y-6">
                {filtered.map(p => {
                    const dateObj = new Date(p.createdAt);
                    const displayDate = `${dateObj.getDate().toString().padStart(2, '0')}/${(dateObj.getMonth() + 1).toString().padStart(2, '0')}/${dateObj.getFullYear()}`;
                    
                    return (
                        <div key={p._id} className="bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all flex flex-col md:flex-row min-h-[260px] select-none">
                            {/* Left Column: Placeholder / Image section (30% width) */}
                            <div className="w-full md:w-[32%] bg-blue-50/40 border-r border-slate-100 p-6 flex flex-col items-center justify-center relative select-none">
                                <div className="text-center">
                                    <div className="text-[#3b82f6] text-xl font-bold mb-4 tracking-wide leading-none select-none">
                                        images <span className="text-slate-800">not available!</span>
                                    </div>
                                    <div className="w-28 h-20 mb-4 mx-auto opacity-80 flex items-center justify-center">
                                        <i className="fa-solid fa-house-chimney-window text-6xl text-[#3b82f6]/40"></i>
                                    </div>
                                    <div className="text-slate-700 font-bold text-xs">
                                        request images directly from owner
                                    </div>
                                </div>
                            </div>

                            {/* Right Column: Card details (68% width) */}
                            <div className="w-full md:w-[68%] p-6 flex flex-col justify-between">
                                {/* Row 1: Title and badging */}
                                <div className="flex flex-wrap items-start justify-between gap-4 mb-4 select-none">
                                    <div>
                                        <h2 className="text-xl font-bold text-[#0f172a] mb-1 leading-none tracking-tight">
                                            {p.buildingName}
                                        </h2>
                                        <div className="flex items-center gap-1.5 text-xs font-medium text-slate-500 mt-1.5">
                                            <span>•</span> <span>{p.propertyCategory}</span>
                                            {p.bhkConfiguration !== 'N/A' && (
                                                <><span>•</span> <span>{p.bhkConfiguration}</span></>
                                            )}
                                            <span>•</span> <span>{p.subCategory}</span>
                                        </div>
                                    </div>

                                    {/* Action tags */}
                                    <div className="flex items-center gap-2 select-none">
                                        <div className="bg-red-50 text-red-500 font-bold text-xs px-3.5 py-1.5 rounded-full border border-red-100">
                                            {displayDate}
                                        </div>
                                        <div className="bg-blue-50 text-blue-600 font-bold text-xs px-3.5 py-1.5 rounded-full border border-blue-100 tracking-wider">
                                            ID: {p._id}
                                        </div>
                                        <button className="w-8 h-8 flex items-center justify-center text-slate-400 hover:text-slate-600 border border-transparent hover:border-slate-200 rounded-full transition-all">
                                            <i className="fa-solid fa-share-nodes text-sm"></i>
                                        </button>
                                    </div>
                                </div>

                                {/* Row 2: 4-Column Grid with vertical thin lines */}
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 py-4 border-t border-b border-slate-100 my-2 select-none text-center md:text-left">
                                    <div className="flex flex-col">
                                        <span className="text-base md:text-lg font-bold text-slate-800">
                                            {p.priceMin ? `₹${(parseInt(p.priceMin) / 100000).toFixed(2)}Lac - ₹${(parseInt(p.priceMax) / 100000).toFixed(2)}Lac` : 'N/A'}
                                        </span>
                                        <span className="text-xs font-bold text-slate-400 mt-0.5">Price Range</span>
                                    </div>

                                    <div className="flex flex-col border-none md:border-l border-slate-100 md:pl-4">
                                        <span className="text-base md:text-lg font-bold text-slate-800">
                                            {p.size} SqFt
                                        </span>
                                        <span className="text-xs font-bold text-slate-400 mt-0.5">Size</span>
                                    </div>

                                    <div className="flex flex-col border-none md:border-l border-slate-100 md:pl-4">
                                        <span className="text-base md:text-lg font-bold text-slate-800">
                                            {p.furnishingType}
                                        </span>
                                        <span className="text-xs font-bold text-slate-400 mt-0.5">Furnished</span>
                                    </div>

                                    <div className="flex flex-col border-none md:border-l border-slate-100 md:pl-4">
                                        <span className="text-base md:text-lg font-bold text-slate-800">
                                            {p.status}
                                        </span>
                                        <span className="text-xs font-bold text-slate-400 mt-0.5">Status</span>
                                    </div>
                                </div>

                                {/* Row 3: Bottom Row */}
                                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 pt-2 select-none">
                                    <div className="flex flex-col">
                                        <div className="flex items-center gap-2 text-slate-700 font-bold text-xs mb-1">
                                            <i className="fa-solid fa-bolt-lightning text-amber-500"></i>
                                            Property Details
                                        </div>
                                        <div className="text-xs font-medium text-slate-500">
                                            ← {p.description}
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-end gap-1.5 select-none self-center md:self-end">
                                        <button className="px-5 py-2.5 bg-indigo-900 hover:bg-indigo-950 text-white rounded-full font-bold text-xs shadow-sm transition-all cursor-pointer">
                                            Get Contact Number
                                        </button>
                                        <span className="text-xs font-bold text-slate-700">
                                            0 people contacted this property today
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </AdminLayout>
    )
}
